<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12.89,8.11C12.89,8.11,12.88,8.12,12.88,8.12C12.88,8.12,12.5,7.74,12.5,7.74C12.5,7.74,12.12,8.12,12.12,8.12C12.12,8.12,12.1,8.1,12.1,8.1C11.56,8.65,10.83,9,10,9C8.34,9,7,7.66,7,6C7,5.17,7.35,4.44,7.9,3.9C7.9,3.9,7.88,3.88,7.88,3.88C7.88,3.88,8.26,3.5,8.26,3.5C8.26,3.5,7.88,3.12,7.88,3.12C7.88,3.12,7.89,3.11,7.89,3.11C7.35,2.57,7,1.83,7,1C7,0.66,7.07,0.35,7.17,0.04C3.14,0.46,0,3.86,0,8C0,12.42,3.58,16,8,16C12.14,16,15.54,12.86,15.96,8.83C15.65,8.93,15.34,9,15,9C14.17,9,13.43,8.65,12.89,8.11C12.89,8.11,12.89,8.11,12.89,8.11ZM13.91,3.5C13.91,3.5,15.7,1.71,15.7,1.71C15.89,1.53,16,1.28,16,1C16,0.45,15.55,0,15,0C14.72,0,14.47,0.11,14.29,0.29C14.29,0.29,12.5,2.09,12.5,2.09C12.5,2.09,10.71,0.3,10.71,0.3C10.53,0.11,10.28,0,10,0C9.45,0,9,0.45,9,1C9,1.28,9.11,1.53,9.29,1.71C9.29,1.71,11.08,3.5,11.08,3.5C11.08,3.5,9.29,5.29,9.29,5.29C9.11,5.47,9,5.72,9,6C9,6.55,9.45,7,10,7C10.28,7,10.53,6.89,10.71,6.71C10.71,6.71,12.5,4.92,12.5,4.92C12.5,4.92,14.29,6.71,14.29,6.71C14.47,6.89,14.72,7,15,7C15.55,7,16,6.55,16,6C16,5.72,15.89,5.47,15.71,5.29C15.71,5.29,13.91,3.5,13.91,3.5C13.91,3.5,13.91,3.5,13.91,3.5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GraphRemove',
} as DefineComponent
</script>
